import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { LogoutFunc as AdvisorLogout } from "../store/Slice/AdvisorAuthSlice";
import { LogoutFunc as UserLogout } from "../store/Slice/AuthSlice";
import ChevronUp from "../assets/images/chevron-up.png";
import profileimage from "../assets/images/profileimage.png";
import { MenuOutlined } from "@ant-design/icons";
import PasswordUpdateModal from "../components/Advisors/MyProfileTabs/PasswordUpdateModal";

const AdvisorHeader = ({ onMenuClick }) => {
  const dispatch = useDispatch();
  const { auth, user } = useSelector((state) => state.advisorauth);
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  
  const [passwordModalOpen, setPasswordModalOpen] = useState(() => {
    return sessionStorage.getItem('passwordModalOpen') === 'true';
  });

  useEffect(() => {
    if (passwordModalOpen) {
      sessionStorage.setItem('passwordModalOpen', 'true');
    } else {
      sessionStorage.removeItem('passwordModalOpen');
    }
  }, [passwordModalOpen]);

  const logout = () => {
    dispatch(AdvisorLogout());
    dispatch(UserLogout());
    navigate("/");
  };

  useEffect(() => {
    if (!auth) {
      navigate("/advisorlogin");
    }
  }, [auth, navigate]);
  return (
    <div className="bg-gradient-to-r from-primary to-primary-green px-4 py-4 lg:px-6 lg:py-6 flex justify-between items-center transition-all duration-200">
      <div className="flex items-center gap-3">
        {onMenuClick && (
          <button
            type="button"
            className="xl:hidden p-2 bg-white rounded-lg shadow-md hover:bg-gray-50 transition-colors"
            aria-label="Toggle menu"
            onClick={onMenuClick}
          >
            <MenuOutlined className="text-xl text-gray-700" />
          </button>
        )}
        <div className="text-white text-base lg:text-lg font-medium">
          <p className="m-0">Hello, {user}</p>
        </div>
      </div>
      <div className="flex items-center justify-end gap-2 lg:gap-3">
        {/* <div className="text-white w-12 text-base cursor-pointer">
          <BellOutlined />
        </div>
        <div className="text-white w-12 text-base cursor-pointer">
          <SettingOutlined />
        </div> */}
        <div className="relative">
          <div
            className="flex items-center gap-1 lg:gap-2 cursor-pointer"
            onClick={() => setDropdownOpen(!dropdownOpen)}
          >
            <img
              src={profileimage}
              alt="Profile"
              className="w-10 h-10 lg:w-12 lg:h-12 rounded-full object-cover flex-shrink-0"
            />
            <img
              src={ChevronUp}
              alt="arrow-up"
              className="w-4 h-4 lg:w-5 lg:h-5 flex-shrink-0 transition-transform duration-200"
              style={{
                transform: dropdownOpen ? "rotate(180deg)" : "rotate(0deg)",
              }}
            />
          </div>
          {dropdownOpen && (
            <div className="absolute top-full mt-2 right-0 min-w-[160px] lg:min-w-[200px] bg-white rounded-lg shadow-lg z-50">
              <div className="py-1">
                <button
                  onClick={() => {
                    setPasswordModalOpen(true);
                    setDropdownOpen(false);
                  }}
                  className="w-full text-left px-4 py-2 lg:py-3 text-sm lg:text-base text-[#222222] hover:bg-gray-100 cursor-pointer border-none bg-transparent transition-colors"
                >
                  Update Password
                </button>
              </div>
              <div className="border-t border-gray-200 my-1"></div>
              <div className="py-1">
                <button
                  onClick={() => {
                    logout();
                    setDropdownOpen(false);
                  }}
                  className="w-full text-left px-4 py-2 lg:py-3 text-sm lg:text-base text-[#222222] hover:bg-gray-100 cursor-pointer border-none bg-transparent transition-colors"
                >
                  Logout
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      <PasswordUpdateModal
        isOpen={passwordModalOpen}
        onClose={() => setPasswordModalOpen(false)}
      />
    </div>
  );
};

export default AdvisorHeader;
